export function isEnumValue<T extends Record<string, string | number>>(
  enumType: T,
  value: string | number
): value is T[keyof T] {
  return Object.values(enumType).includes(value);
}
